import React from 'react'
import styled from '@emotion/styled'
import { Button, ButtonProps, IconButton } from '@mui/material'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'

const StyledRoundedBtn = styled(Button)({
  borderRadius: '24px'
})

const StyledSquaredBtn = styled(Button)({
  borderRadius: '16px'
})

const IconButtonStyled = styled(IconButton)({
  borderRadius: '8px',
  color: circlesOrbitColorPalette.primary.main,
  padding: '0px 16px 0px 0px',
  '&:hover': {
    backgroundColor: circlesOrbitColorPalette.neutrals[100]
  }
})

export const RoundedButton = (props: ButtonProps) => {
  const { children, ...otherProps } = props
  return <StyledRoundedBtn {...otherProps}>{children}</StyledRoundedBtn>
}

export const SquaredButton = (props: ButtonProps) => {
  const { children, ...otherProps } = props

  return <StyledSquaredBtn {...otherProps}>{children}</StyledSquaredBtn>
}

export const StyledIconButton = (props: ButtonProps) => {
  const { children, ...otherProps } = props

  return <IconButtonStyled {...otherProps}>{children}</IconButtonStyled>
}
